import React from 'react';
import Icon from '../../../icons/Icon';
import { VtexButton } from '../../../styleguide/VtexButton';
import { Props } from '../BackToTopButton';

const handleBackTop = () => {
	window.scroll({ top: 0, left: 0, behavior: 'smooth' });
};

const BackToTopButtonElement = ({ displayThreshold = 600, display = 'button', componentId }: Props) => {
	const [isShowed, setIsShowed] = React.useState(false);
	const [scrollY, setScrollY] = React.useState(0);
	const backToTopButtonClasses = `z-9999 fixed bottom-2 right-2 backToTopButtonActive backToTopButtonContainer vtex-store-components-3-x-backToTopButtonActive vtex-store-components-3-x-backToTopButtonContainer `;
	function scrollValue(html: any) {
		setScrollY(html.scrollTop);
	}

	React.useEffect(() => {
		const iframe = document.querySelector('iframe')?.contentDocument as any;
		const html = (iframe?.querySelector('.canvas') || document.querySelector('.canvas')) as any;
		html.addEventListener('scroll', () => {
			scrollValue(html);
		});

		return () => {
			html.removeEventListener('scroll', () => {
				scrollValue(html);
			});
		};
	}, []);

	React.useEffect(() => {
		if (scrollY > displayThreshold) {
			setIsShowed(true);
		} else {
			setIsShowed(false);
		}
	}, [scrollY, displayThreshold]);

	if (!isShowed) {
		return null;
	}

	return display === 'button' ? (
		<div data-selection={componentId} className={backToTopButtonClasses}>
			<VtexButton handleClick={handleBackTop} size="regular">
				Voltar para o topo
			</VtexButton>
		</div>
	) : (
		<div data-selection={componentId} className={backToTopButtonClasses}>
			<VtexButton handleClick={handleBackTop} size="regular">
				<Icon handle={' '} id="nav-caret--up" size={16} />
			</VtexButton>
		</div>
	);
};

export default BackToTopButtonElement;
